package device

enum class DevicePath {
    DEVICE_DETAIL,
    DEVICE_QUICK_CHECK,
    DEVICE_STATION_LIST
}